import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { SERVICES } from "../lib/services";

const FEATURED = SERVICES.slice(0, 8);
const REMAINING = SERVICES.length - FEATURED.length;

// Replaces the old 3D scene with real, on-brand content: a live-looking
// snapshot of the actual service catalog instead of a generic animation.
export const HeroShowcase = () => (
  <div className="relative h-full w-full kb-glass rounded-3xl p-8 md:p-10 flex flex-col overflow-hidden" data-testid="hero-showcase">
    <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#d4a840]/10 blur-3xl pointer-events-none" />
    <div className="absolute -bottom-28 -left-16 h-64 w-64 rounded-full bg-[#0a1f4d]/60 blur-3xl pointer-events-none" />

    <div className="relative">
      <div className="kb-label mb-3">Everything Under One Roof</div>
      <h3 className="font-display text-2xl md:text-[1.75rem] font-bold text-white leading-snug max-w-sm">
        14+ compliance verticals, <span className="italic text-[#d4a840]">one accountable partner.</span>
      </h3>
    </div>

    <div className="relative flex-1 flex flex-col justify-center py-8 md:py-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8">
        {FEATURED.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div
              key={s.slug}
              initial={{ opacity: 0, x: -14 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.25 + i * 0.06, duration: 0.5, ease: "easeOut" }}
              className={`flex items-center gap-3 py-3.5 ${i !== FEATURED.length - 1 ? "border-b border-white/5" : ""}`}
              data-testid={`hero-showcase-item-${s.slug}`}
            >
              <div className="h-9 w-9 rounded-lg bg-[#d4a840]/10 border border-[#d4a840]/30 flex items-center justify-center shrink-0">
                <Icon size={16} className="text-[#d4a840]" />
              </div>
              <span className="text-sm text-white/80 leading-snug">{s.title}</span>
            </motion.div>
          );
        })}
      </div>
    </div>

    <div className="relative flex items-center gap-3 pt-6 border-t border-[#d4a840]/15">
      <div className="h-9 w-9 rounded-full bg-[#d4a840]/15 border border-[#d4a840]/40 flex items-center justify-center shrink-0">
        <ShieldCheck size={16} className="text-[#d4a840]" />
      </div>
      <div className="text-xs text-white/50 leading-relaxed">
        Plus <span className="text-[#d4a840] font-semibold">{REMAINING} more verticals</span> — see the full catalog on the Services page.
      </div>
    </div>
  </div>
);
